import { Box, Flex, Text } from "@chakra-ui/react";
import LocalSpinner from "../../../../components/LocalSpinner";
import { getFormattedNumValue } from "../../../../utils";
import DashboardCard from "../../../ISSB/Dashboard/components/DashboardCard";
import BigNumber from "../components/BigNumber";
import { getYoYChange } from "../../../../utils/yoy";

/**
 * @param {Object} p
 * @param {Object} p.currentYear Comes from useGetSupplierOverviewData
 * @param {Object} p.previousYear
 * @param {string} p.theme
 * @returns {JSX.Element}
 */
const ActiveSupplierCard = ({ isLoading, currentYear, previousYear, theme = "light" }) => {
  const colors = {
    light: { cardBg: "#F7FAFC", title: "teal", value: "teal.900" },
    dark: { cardBg: "pureBlack", title: "pureWhite", value: "lightLime" },
  };
  const t = colors[theme] || colors.light;

  // YoY change of declared-supplier spend — a decrease is an improvement,
  // matching YoYChip's default down=green semantics.
  const spendYoy = getYoYChange(
    currentYear?.spendsForEmissionDeclaredSupplier,
    previousYear?.spendsForEmissionDeclaredSupplier
  );

  // Share of total spend that comes from emission-declared suppliers (a
  // proportion, not a YoY change) — shown as a plain labelled figure.
  const spendPercentage =
    ((currentYear?.spendsForEmissionDeclaredSupplier || 0) / (currentYear?.totalSpend || 1)) * 100;

  return (
    <DashboardCard bg={t.cardBg} px={6}>
      <Text fontSize="body.2xl" fontWeight="bold" color={t.title}>
        Active Suppliers
      </Text>
      {isLoading ? (
        <LocalSpinner size="sm" />
      ) : (
        <Flex direction="column" gap={8} height="100%" justify="space-between">
          <Box mb={4}>
            <Flex align="baseline" gap={2}>
              <BigNumber color={t.value}>{currentYear?.totalSuppliersWithData || 0}</BigNumber>
              <Text fontSize="body.l" color="gray.400" fontWeight="600">
                / {currentYear?.supplierCountWithRequestedData || 0}
              </Text>
            </Flex>
            <Text fontSize="body.xs" color="gray.500" mt={1}>
              with data / requested
            </Text>
          </Box>

          <Box>
            <Text fontSize="body.s" fontWeight="semibold" color="gray.500">
              Spend
            </Text>
            <BigNumber color={t.value} pctChange={spendYoy}>
              £ {getFormattedNumValue(currentYear?.spendsForEmissionDeclaredSupplier, 2, true) || 0}
            </BigNumber>
            <Text fontSize="body.xs" color="gray.500" mt={1}>
              Company provided (£1m)
            </Text>
          </Box>

          <Box>
            <Text fontSize="body.s" fontWeight="semibold" color="gray.500">
              Share of total spend
            </Text>
            <Text fontSize="body.l" fontWeight="700" color={t.value}>
              {getFormattedNumValue(spendPercentage, 2) || 0} %
            </Text>
          </Box>
        </Flex>
      )}
    </DashboardCard>
  );
};

export default ActiveSupplierCard;
